import { HoursDto } from 'gleblu-socket-api';
import { Map } from 'immutable';

import Hours, { RegularHour } from '../interfaces/Hours';
import { fromDto as specialHourFromDto } from './SpecialHourAdapter';

export function fromDto(hoursDto: HoursDto): Hours {
  const { placeUuid, regularHours, specialHours } = hoursDto;
  const regularHourByWeekday = regularHours.map((regularHour): [number, RegularHour] => [regularHour.dayIndex, regularHour as RegularHour]);
  return {
    placeUuid,
    regularHours: Map<number, RegularHour>(regularHourByWeekday),
    specialHours: specialHours.map((specialHour) => specialHourFromDto(specialHour)),
  };
}

export function toDto(_: Hours): HoursDto {
  throw new Error('Not implemented!');
}
